"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _FavoriteBorder = _interopRequireDefault(require("@material-ui/icons/FavoriteBorder"));
var HeroFooter = function HeroFooter(_ref) {
  var className = _ref.className;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: (0, _classnames["default"])('max-w-lg w-2/3', className)
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-white font-light text-sm opacity-50"
  }, t('heroFooter.subtitle'), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-base ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_FavoriteBorder["default"], {
    fontSize: "inherit"
  }))));
};
HeroFooter.defaultProps = {
  className: ''
};
var _default = exports["default"] = HeroFooter;
//# sourceMappingURL=index.js.map